var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResourceDetail',{attrs:{"component-testid":"cluster-manager-create"}})
}
var staticRenderFns = []

export { render, staticRenderFns }